import type { FaireProductEntity } from "../../entity_types/product";

export const p_p8tdzp7xfx: FaireProductEntity = {
  token: "p_p8tdzp7xfx",
  type: "product",
  name: "Super Green - Wholesale",
  brandToken: "b_7piiqmq04r",
  brandName: "Lake & Oak Tea Co.",
  imageUrl: "https://cdn.faire.com/fastly/793bfba5dc974bbd08197079354fed2a7bd4e03dcae549d4917b364e24e21e67.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/73fc02fc7ab9ac11d5fb68803cff32c7f365f35d414a59fe961885ca6c81adca.png",
    "https://cdn.faire.com/fastly/e123654450627d4069227c856e7d0f84af2a111facabb9cd9b80920f1e1a2fd3.jpeg"
  ],
  priceDollars: 9.8,
  description: "SUPERFOOD TEA BLEND\n\nThis green goddess was designed to keep you going (and glowing) all day, with free-radical scavenger green tea, Japanese matcha, and adaptogenic moringa leaf. \n\nRefreshing lemongrass and lemon myrtle bring balance to every energizing and detoxifying sip.\n\n100% ORGANIC - ADAPTOGENIC - NUTRITIONIST FORMULATED \n\nHow to Enjoy:\n\n * Steep tea in 1 cup of 80° water for 4-6 minutes. \n * Try me with a squeeze of lemon. \n * Try me iced or cold-brewed for a hydrating and cleansing tonic. \nWhen to Steep:\n\n\n * For a smooth, feel-good boost of energy \n * Before a workout \n * Iced as a refreshing summer tonic\n\nModerate caffeine levels\n",
  tags: [],
  msrpDollars: 15.5,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-09-07T19:04:44.103Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
